export default __webpack_public_path__ + "static/media/drum-mobile.00db3a72.jpg";